import * as React from "react";
import { useMemo } from "react";
import IlluminateInstallStatus from "illuminate/components/illuminate/IlluminateInstallStatus";
import { useGetInstallationStatus } from "illuminate/hooks/useBundlesAPI";
export const PacksInstallStatus = ({ children }) => {
  const { installationStatus } = useGetInstallationStatus();
  const { install_in_progress: installInProgress } = useMemo(() => installationStatus, [installationStatus]);
  if (!installInProgress) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  }
  return /* @__PURE__ */ React.createElement(IlluminateInstallStatus, { installStatusObj: installationStatus });
};
export default PacksInstallStatus;
